import { StrictMode } from 'react'
import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/queryClient'
import { initSentry } from './utils/sentry'
import './index.css'
import App from './App.tsx'

// Initialize Sentry error tracking (no-op if DSN not configured)
initSentry();

// Wire Signatures notification adapter (must run before any signature notifications)
import { setSignatureNotificationAdapter } from './signatures/adapters/NotificationAdapter';
import { CommunicationsHubNotificationAdapter } from './signatures/adapters/CommunicationsHubNotificationAdapter';
setSignatureNotificationAdapter(new CommunicationsHubNotificationAdapter());

console.log('[Main] Starting minimal React app initialization');
console.log('[Main] React version:', React.version);
localStorage.setItem('app_init_start', new Date().toISOString());

// Remove loading fallback
const loadingFallback = document.getElementById('loading-fallback');
if (loadingFallback) {
  console.log('[Main] Removing loading fallback');
  loadingFallback.remove();
  localStorage.setItem('app_loading_removed', new Date().toISOString());
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  document.body.innerHTML = '<div style="padding: 40px; text-align: center; background: #fee; color: #c00; font-family: system-ui;">ERROR: Root element not found!</div>';
  throw new Error('Root element not found');
}

try {
  console.log('[Main] Attempting to mount minimal React app');
  createRoot(rootElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>,
  );
  console.log('[Main] React app mounted successfully');
  localStorage.setItem('app_mounted', new Date().toISOString());
} catch (error) {
  console.error('[Main] Failed to mount React app:', error);
  localStorage.setItem('app_mount_error', JSON.stringify({
    error: error instanceof Error ? error.message : 'Unknown error',
    stack: error instanceof Error ? error.stack : undefined,
    timestamp: new Date().toISOString()
  }));
  rootElement.innerHTML = `
    <div style="padding: 40px; text-align: center; background: #fee; color: #c00; font-family: system-ui;">
      <h1>Failed to load application</h1>
      <p>${error instanceof Error ? error.message : 'Unknown error'}</p>
      <details style="margin-top: 20px; text-align: left; max-width: 600px; margin-left: auto; margin-right: auto;">
        <summary style="cursor: pointer;">Error Details</summary>
        <pre style="background: #f5f5f5; padding: 10px; overflow-x: auto;">${error instanceof Error ? error.stack : 'No stack trace'}</pre>
      </details>
    </div>
  `;
}
